module.exports = __webpack_public_path__ + "static/img/exam_start.0b8fd0c3.png";